/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckDNSRecordRequest,
  CheckUploadedFileRequest,
  GeneralCheckResult,
  OrgResearchRequestDto,
} from '../models/index';
import {
    CheckDNSRecordRequestFromJSON,
    CheckDNSRecordRequestToJSON,
    CheckUploadedFileRequestFromJSON,
    CheckUploadedFileRequestToJSON,
    GeneralCheckResultFromJSON,
    GeneralCheckResultToJSON,
    OrgResearchRequestDtoFromJSON,
    OrgResearchRequestDtoToJSON,
} from '../models/index';

export interface BoundOrgResearchRequest {
    orgResearch: string;
    org?: string;
}

export interface CheckDNSRecordOperationRequest {
    checkDNSRecordRequest: CheckDNSRecordRequest;
}

export interface CheckUploadedFileOperationRequest {
    checkUploadedFileRequest: CheckUploadedFileRequest;
}

export interface DeleteOrgResearchRequest {
    orgResearchId: string;
}

export interface FindById1Request {
    orgResearchId: string;
}

export interface FindByOrgId1Request {
    orgId: string;
}

export interface SaveByIdRequest {
    orgResearchId: string;
    orgResearchRequestDto: OrgResearchRequestDto;
}

/**
 * 
 */
export class OrgResearchControllerApi extends runtime.BaseAPI {

    /**
     * Bounds org-research with some registered org
     */
    async boundOrgResearchRaw(requestParameters: BoundOrgResearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['orgResearch'] == null) {
            throw new runtime.RequiredError(
                'orgResearch',
                'Required parameter "orgResearch" was null or undefined when calling boundOrgResearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orgResearch'] != null) {
            queryParameters['org-research'] = requestParameters['orgResearch'];
        }

        if (requestParameters['org'] != null) {
            queryParameters['org'] = requestParameters['org'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/researched-org/linkage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bounds org-research with some registered org
     */
    async boundOrgResearch(requestParameters: BoundOrgResearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.boundOrgResearchRaw(requestParameters, initOverrides);
    }

    /**
     * Check DNS text record for domain
     */
    async checkDNSRecordRaw(requestParameters: CheckDNSRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralCheckResult>> {
        if (requestParameters['checkDNSRecordRequest'] == null) {
            throw new runtime.RequiredError(
                'checkDNSRecordRequest',
                'Required parameter "checkDNSRecordRequest" was null or undefined when calling checkDNSRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/researched-org/text-record`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckDNSRecordRequestToJSON(requestParameters['checkDNSRecordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralCheckResultFromJSON(jsonValue));
    }

    /**
     * Check DNS text record for domain
     */
    async checkDNSRecord(requestParameters: CheckDNSRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralCheckResult> {
        const response = await this.checkDNSRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check uploaded file for domain
     */
    async checkUploadedFileRaw(requestParameters: CheckUploadedFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralCheckResult>> {
        if (requestParameters['checkUploadedFileRequest'] == null) {
            throw new runtime.RequiredError(
                'checkUploadedFileRequest',
                'Required parameter "checkUploadedFileRequest" was null or undefined when calling checkUploadedFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/researched-org/uploaded-file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckUploadedFileRequestToJSON(requestParameters['checkUploadedFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralCheckResultFromJSON(jsonValue));
    }

    /**
     * Check uploaded file for domain
     */
    async checkUploadedFile(requestParameters: CheckUploadedFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralCheckResult> {
        const response = await this.checkUploadedFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete org research parameters for org-research-id
     */
    async deleteOrgResearchRaw(requestParameters: DeleteOrgResearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['orgResearchId'] == null) {
            throw new runtime.RequiredError(
                'orgResearchId',
                'Required parameter "orgResearchId" was null or undefined when calling deleteOrgResearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/researched-org/{org-research-id}`.replace(`{${"org-research-id"}}`, encodeURIComponent(String(requestParameters['orgResearchId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete org research parameters for org-research-id
     */
    async deleteOrgResearch(requestParameters: DeleteOrgResearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteOrgResearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get org research parameters for org-research-id
     */
    async findById1Raw(requestParameters: FindById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgResearchRequestDto>> {
        if (requestParameters['orgResearchId'] == null) {
            throw new runtime.RequiredError(
                'orgResearchId',
                'Required parameter "orgResearchId" was null or undefined when calling findById1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/researched-org/{org-research-id}`.replace(`{${"org-research-id"}}`, encodeURIComponent(String(requestParameters['orgResearchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgResearchRequestDtoFromJSON(jsonValue));
    }

    /**
     * Get org research parameters for org-research-id
     */
    async findById1(requestParameters: FindById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgResearchRequestDto | null | undefined > {
        const response = await this.findById1Raw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get org research that is associated with the org id
     */
    async findByOrgId1Raw(requestParameters: FindByOrgId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgResearchRequestDto>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling findByOrgId1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/researched-org/org/{org-id}`.replace(`{${"org-id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgResearchRequestDtoFromJSON(jsonValue));
    }

    /**
     * Get org research that is associated with the org id
     */
    async findByOrgId1(requestParameters: FindByOrgId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgResearchRequestDto | null | undefined > {
        const response = await this.findByOrgId1Raw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Save org research parameters for org-research-id
     */
    async saveByIdRaw(requestParameters: SaveByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['orgResearchId'] == null) {
            throw new runtime.RequiredError(
                'orgResearchId',
                'Required parameter "orgResearchId" was null or undefined when calling saveById().'
            );
        }

        if (requestParameters['orgResearchRequestDto'] == null) {
            throw new runtime.RequiredError(
                'orgResearchRequestDto',
                'Required parameter "orgResearchRequestDto" was null or undefined when calling saveById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/researched-org/{org-research-id}`.replace(`{${"org-research-id"}}`, encodeURIComponent(String(requestParameters['orgResearchId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgResearchRequestDtoToJSON(requestParameters['orgResearchRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save org research parameters for org-research-id
     */
    async saveById(requestParameters: SaveByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveByIdRaw(requestParameters, initOverrides);
    }

}
